import { useContext } from 'react';

import { rootStoreContext } from '@app/store';

export const useStores = () => useContext(rootStoreContext);
